import { render, staticRenderFns } from "./AssignmentTypeSection.vue?vue&type=template&id=a03f2882&scoped=true&"
import script from "./AssignmentTypeSection.vue?vue&type=script&lang=js&"
export * from "./AssignmentTypeSection.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTypeSection.vue?vue&type=style&index=0&id=a03f2882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03f2882",
  null
  
)

export default component.exports